import * as s from './style'

type Props = {
    name: string,
    type: string,
    price: number,
    icon: any
}

const Transitions: React.FC<Props> = ({name, type, price, icon}) => {
    return(
        <s.container>
            {icon}

            <div className='container-datas' >
                <p>{name}</p>
                <span>{type}</span>
            </div>

            <div className='container-price'>
                <span>$</span>
                {price}
            </div>
        </s.container>
    )
}

export default Transitions